<template>
    <div class="OkCheap">
        <slot />
    </div>
</template>

<style lang="scss" scoped src="./index.scss" />
